import { getI18n } from 'react-i18next';

export const VALIDATION_REQUEST_RATE_LIMIT_EMPTY_REQUEST_TYPE = 'validation.requestRateLimit.emptyRequestType';
export const VALIDATION_REQUEST_RATE_LIMIT_INVALID_USER = 'validation.requestRateLimit.invalidUser';
export const VALIDATION_REQUEST_RATE_LIMIT_EMPTY_VALUE = 'validation.requestRateLimit.emptyValue';
export const VALIDATION_REQUEST_RATE_LIMIT_VALUE_TOO_LOW = 'validation.requestRateLimit.valueTooLow';
export const VALIDATION_REQUEST_RATE_LIMIT_VALUE_TOO_HIGH = 'validation.requestRateLimit.valueTooHigh';
export const VALIDATION_REQUEST_RATE_LIMITS_DUPLICATE_USER_REQUEST_TYPE_COMBINATION = 'validation.requestRateLimits.duplicateUserRequestTypeCombination';
export const ERROR_REQUEST_RATE_LIMITS_AMQP_DISABLED = 'requestRateLimits.amqpDisabled';

export const createRequestRateLimitErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_REQUEST_RATE_LIMIT_EMPTY_REQUEST_TYPE:
            result = i18n.t('settings.request-rates-and-limits.error.request-rate-limit-empty-request-type');
            break;
        case VALIDATION_REQUEST_RATE_LIMIT_INVALID_USER:
            result = i18n.t('settings.request-rates-and-limits.error.request-rate-limit-invalid-user');
            break;
        case VALIDATION_REQUEST_RATE_LIMIT_EMPTY_VALUE:
            result = i18n.t('settings.request-rates-and-limits.error.request-rate-limit-empty-value');
            break;
        case VALIDATION_REQUEST_RATE_LIMIT_VALUE_TOO_LOW:
            result = i18n.t('settings.request-rates-and-limits.error.request-rate-limit-value-too-low', { value: params[0] });
            break;
        case VALIDATION_REQUEST_RATE_LIMIT_VALUE_TOO_HIGH:
            result = i18n.t('settings.request-rates-and-limits.error.request-rate-limit-value-too-high', { value: params[0] });
            break;
        case VALIDATION_REQUEST_RATE_LIMITS_DUPLICATE_USER_REQUEST_TYPE_COMBINATION:
            result = i18n.t('settings.request-rates-and-limits.error.request-rate-limits-duplicate-user-request-type-combination');
            break;
        case ERROR_REQUEST_RATE_LIMITS_AMQP_DISABLED:
            result = i18n.t('settings.request-rates-and-limits.error.request-rate-limits-amqp-disabled');
            break;
        default:
            result = undefined;
    }
    return result;
};
